import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/redirect-check")({
  component: lazyRouteComponent(() => import("./-pages/admin.redirect-check")),
  head: () => ({
    meta: [
      { title: "Legacy Redirects · Lecmo Admin" },
      { name: "description", content: "Review legacy Lecmo URLs and verified redirect destinations." },
      { property: "og:title", content: "Legacy Redirects · Lecmo Admin" },
      { property: "og:description", content: "Review legacy Lecmo URLs and verified redirect destinations." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
